<template>
    <el-dialog
        title="Add a new Currency"
        width="500px"
        :visible="show"
        :before-close="beforeClose"
        :append-to-body="true"
        @close="onCancelClick()"
    >
        <el-form :model="form" ref="form" label-width="190px" label-position="right" :rules="rules">
            <h3>Basics</h3>
            <el-form-item label="Currency name" prop="asset_name">
                <el-input
                    v-model="form.asset_name"
                    autocomplete="off"
                    placeholder="Currency name"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="Description" prop="description">
                <el-input type="textarea" v-model="form.description" autocomplete="off" clearable maxlength="255"></el-input>
            </el-form-item>
            <el-form-item label="Currency type" prop="type">
                <el-select v-model="form.type" placeholder="Please select">
                    <el-option label="TOKEN" value="TOKEN"></el-option>
                    <el-option label="FIAT" value="FIAT"></el-option>
                </el-select>
            </el-form-item>
            <h3>Exchange</h3>
            <el-form-item label="Exchange fee fixed" prop="exchange_fee_fixed">
                <el-input
                    v-model="form.exchange_fee_fixed"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Exchange fee percentage" prop="exchange_fee_percentage">
                <el-input
                    v-model="form.exchange_fee_percentage"
                    autocomplete="off"
                    type="number"
                    min="0"
                    max="1"
                    clearable
                >
                    <template slot="append">={{numeral(form.exchange_fee_percentage).format('0.00%')}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Exchange cost fixed" prop="exchange_cost_fixed">
                <el-input
                    v-model="form.exchange_cost_fixed"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Exchange cost percentage" prop="exchange_cost_percentage">
                <el-input
                    v-model="form.exchange_cost_percentage"
                    autocomplete="off"
                    type="number"
                    min="0"
                    max="1"
                    clearable
                >
                    <template slot="append">={{numeral(form.exchange_cost_percentage).format('0.00%')}}</template>
                </el-input>
            </el-form-item>
            <h3>Transfer</h3>
            <el-form-item label="Transfer cost fixed" prop="transfer_cost_fixed">
                <el-input
                    v-model="form.transfer_cost_fixed"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Transfer cost percentage" prop="transfer_cost_percentage">
                <el-input
                    v-model="form.transfer_cost_percentage"
                    autocomplete="off"
                    type="number"
                    min="0"
                    max="1"
                    clearable
                >
                    <template slot="append">={{numeral(form.transfer_cost_percentage).format('0.00%')}}</template>
                </el-input>
            </el-form-item>
            <h3>Withdraw</h3>
            <el-form-item label="Withdraw cost fixed" prop="withdraw_cost_fixed">
                <el-input
                    v-model="form.withdraw_cost_fixed"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Withdraw cost percentage" prop="withdraw_cost_percentage">
                <el-input
                    v-model="form.withdraw_cost_percentage"
                    autocomplete="off"
                    type="number"
                    min="0"
                    max="1"
                    clearable
                >
                    <template slot="append">={{numeral(form.withdraw_cost_percentage).format('0.00%')}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Withdraw fee fixed" prop="withdraw_fee_fixed">
                <el-input
                    v-model="form.withdraw_fee_fixed"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Withdraw fee percentage" prop="withdraw_fee_percentage">
                <el-input
                    v-model="form.withdraw_fee_percentage"
                    autocomplete="off"
                    type="number"
                    min="0"
                    max="1"
                    clearable
                >
                    <template slot="append">={{numeral(form.withdraw_fee_percentage).format('0.00%')}}</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Minimum withdraw amount" prop="min_withdraw_amount">
                <el-input
                    v-model="form.min_withdraw_amount"
                    autocomplete="off"
                    type="number"
                    min="0"
                    clearable
                >
                    <template slot="append">{{form.asset_name}}</template>
                </el-input>
            </el-form-item>
            <h3>Accounts</h3>
            <el-form-item label="Fee account" prop="fee_account_display_name">
                <el-autocomplete
                    popper-class="authenticate-autocomplete"
                    v-model="form.fee_account_display_name"
                    :fetch-suggestions="searchUser"
                    placeholder="Type in name"
                    @select="onFeeAccountSelect"
                >
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="display_name">{{ (item.display_name||item.email).split('@')[0] }}</div>
                        <span class="email">{{ item.email }}</span>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="Cost account" prop="cost_account_display_name">
                <el-autocomplete
                    popper-class="authenticate-autocomplete"
                    v-model="form.cost_account_display_name"
                    :fetch-suggestions="searchUser"
                    placeholder="Type in name"
                    @select="onCostAccountSelect"
                >
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="display_name">{{ (item.display_name||item.email).split('@')[0] }}</div>
                        <span class="email">{{ item.email }}</span>
                    </template>
                </el-autocomplete>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancelClick">Cancel</el-button>
            <el-button @click="onSubmit" type="primary">Save</el-button>
        </div>
    </el-dialog>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import numeral from 'numeral';

export default {
    name: "AdimCurrencyNew",
    props: {
        data: Object,
        show: { default: false },
        onClose: Function
    },
    components: {},
    data() {
        return {
            editor: ClassicEditor,
            form: {
                asset_name: "",
                description: "",
                type: "TOKEN",
                exchange_fee_fixed: 0,
                exchange_fee_percentage: 0.1,
                exchange_cost_fixed: 0,
                exchange_cost_percentage: 0.1,
                transfer_cost_fixed: 0,
                transfer_cost_percentage: 0.1,
                withdraw_cost_fixed: 0,
                withdraw_cost_percentage: 0.1,
                withdraw_fee_fixed: 0,
                withdraw_fee_percentage: 0.1,
                min_withdraw_amount: 0,
                fee_account_id: null,
                fee_account_display_name: "",
                fee_account_email: "",
                cost_account_id: null,
                cost_account_display_name: "",
                cost_account_email: ""
            },
            rules: {
                asset_name: [
                    {
                        required: true,
                        message: "Currency name is required",
                        trigger: "blur"
                    }
                ],
                type: [
                    {
                        required: true,
                        message: "Currency type is required",
                        trigger: "blur"
                    }
                ],
                fee_account_id: [
                    {
                        required: true,
                        message: "Fee account is required",
                        trigger: "blur"
                    }
                ],
                cost_account_id: [
                    {
                        required: true,
                        message: "Cost account is required",
                        trigger: "blur"
                    }
                ]
            },
            processing: false,
            processing_search: false,
        };
    },
    watch: {
        data(newData) {
            if (newData) {
                this.form.title = newData.title;
                this.form.description = newData.description;
                this.form.sort_order = newData.sort_order;
            }
        },
        show(show) {
            if(show) {
                this.loadCybavoData();
            }
        }
    },
    mounted() {
        if (this.data) {
            this.form.title = this.data.title;
            this.form.description = this.data.description;
            this.form.sort_order = this.data.sort_order;
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.accessToken,
            editorConfig: state => state.editorConfig,
            adminPerms: state => state.adminPerms,
        })
    },
    methods: {
        ...mapActions(["request", "getError"]),
        numeral,
        beforeClose(done = () => {}) {
            this.form.title = "";
            this.form.description = "";
            this.form.sort_order = 0;
            done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        validateForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        searchUser(queryString = "", callback = () => {}) {
            if(!queryString || queryString.length == 0) {
                return;
            }
            let ctrl = this;
            ctrl.processing_search = true;
            let query = `authenticate?
                limit=10&where=activated=1 
                AND disabled=0 `;
            if (queryString.trim().length > 0) {
                query += ` AND (display_name LIKE '%${queryString}%' OR email LIKE '%${queryString}%') `;
            }

            let endpoint = encodeURI(query);

            ctrl.request({
                method: "GET",
                endpoint
            })
                .then(({ data = {} }) => {
                    callback(data.results);
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                        title: "AUTHENTICATE_ERROR",
                        message: "Get authenticate users Failed"
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    ctrl.processing_search = false;
                });
        },
        onFeeAccountSelect(item) {
            this.form.fee_account_display_name = item.display_name || item.email;
            this.form.fee_account_id = item.id;
        },
        onCostAccountSelect(item) {
            this.form.cost_account_display_name = item.display_name || item.email;
            this.form.cost_account_id = item.id;
        },
        
        onSubmit() {
            let ctrl = this;
            if(!ctrl.adminPerms || !ctrl.adminPerms.currency || ctrl.adminPerms.currency.length == 0 || !ctrl.adminPerms.currency[0].add_currency){
                ctrl.getError({
                    title: "PERMISSION_ERROR",
                    message: "Permission Denied"
                }).then(ctrl.$notify);
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    ctrl.processing = true;
                    let method = "POST";
                    let endpoint = `currencies`;
                    let options = {
                        method,
                        endpoint,
                        data: ctrl.form
                    };

                    ctrl.request(options)
                        .then(() => {
                            if (ctrl.data) {
                                this.$message({
                                    message: "Currency has been updated",
                                    type: "success"
                                });
                            } else {
                                this.$message({
                                    message: "New currency has been added",
                                    type: "success"
                                });
                            }
                            setTimeout(() => {
                                ctrl.onCancelClick(true);
                            }, 1000);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "CURRENCY_ERROR",
                                message: "Add currency Failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style scoped>
.slider-list {
    background-color: #eee;
}

.new-permission-btn {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.new-permission-btn:hover {
    color: #fff;
    background-color: #00669a;
}

.new-permission-btn:active {
    color: #fff;
    background-color: #177CB0;
}
.load-more {
    width: 100%;
    line-height: 50px;
    cursor: pointer;
    color: #fff;
    text-align: center;
    border: 1px solid #eee;
    margin-top: 16px;
}
.load-more:hover {
    color: #fff;
    background-color: #00669a;
}

.load-more:active {
    color: #fff;
    background-color: #177CB0;
}
.display_name {
    font-size: 12px;
    line-height: 12px;
    color: rgba(0,0,0,0.5);
    padding-top: 10px;
}
</style>

<style >
.slider-list-item {
    cursor: pointer;
}
</style>